export default __webpack_public_path__ + "static/media/account-security.45c8e5fe.png";